import { Button, Card, Col, message, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { jsonrepair } from "jsonrepair";
import moment from "moment";

import { controller as treatmentsController } from "../TreatmentPlans/controller";
import { statusLableColor } from "./statusLableColor";
import { controller } from "../../controller";

import InsuranceBreakDownProceduresTable from "./InsuranceBreakDownProceduresTable";
import InsuranceBreakDownUploadedFile from "./InsuranceBreakDownUploadedFile";
import BreakdownFinanceLabel from "./BreakdownFinanceLabel";
import PatientDropdown from "./PatientDropDown";
import AddPatientModal from "./AddPatientModal";
import ApproveButton from "./ApproveButton";

import arrowLeft from "../../assets/icons/arrow-left.svg";
import SelectPolicyItemModal from "./SelectPolicyItemModal";

export default function InsuranceBreakDownDetails({ selectedBreakdown, setSelectedBreakdown, setSummaryOfSelectedBreakdown }) {
  const [isLoadingInsuranceData, setIsLoadingBreakdownsData] = useState(false);
  const [isGettingProcedures, setIsGettingProcedures] = useState(false); // Loading for the time that all procedures are fetching
  const [isSettingPatientId, setIsSettingPatientId] = useState(false); // Loading for the time that insurance patient is changed
  const [isGettingPatients, setIsGettingPatients] = useState(false); // Loading for the time that all patients are fetching
  const [showAddPatient, setShowAddPatient] = useState(false); // Loading for the time that insurance patient is changed
  const [isApproving, setIsApproving] = useState(false);
  const [isApproved, setIsApproved] = useState(false); // For later
  const [tableData, setTableData] = useState(null);
  const [data, setData] = useState(null);
  const [allProcedures, setAllProcedures] = useState([]);
  const [allPatients, setAllPatients] = useState([]); // All office patients
  const [breakdownStatusLabelColor, setBreakdownStatusLabelColor] = useState({ statusBackgroundColor: null, statusColor: null });
  const [tempSelectedPatients, setTempSelectedPatients] = useState({ temp_patient: null, selected_patient: null });
  const [isPatientDropdownEmpty, setIsPatientDropdownEmpty] = useState(true);
  const [showSelectPolicyItemModal, setShowSelectPolicyItemModal] = useState(false);
  const [patientName, setPatientName] = useState("");
  const [breakdownPatientCoverageData, setBreakdownPatientCoverageData] = useState(undefined);
  const [selectedPatient, setSelectedPatient] = useState(undefined);
  const [breakdownStatus, setBreakdownStatus] = useState(undefined);

  // Getting breakdowns details
  const fetchData = async () => {
    if (selectedBreakdown && selectedBreakdown.id) {
      const response = await controller.getInsuranceBreakdownsPatientDetails(selectedBreakdown.id);

      setTableData(response.json.patient_procedure_coverages);
      setData(response.json);

      if (response.status === "approved") {
        const breakdownPatientCoverageResponse = await controller.getBreakdownPatientCoverage(response.json.patient);
        setBreakdownPatientCoverageData(breakdownPatientCoverageResponse.json);
      }
      if (response.json.text) setPatientName(JSON.parse(jsonrepair(response.json.text)).patient_name);
    }
  };

  // Getting all office patients
  useEffect(function () {
    getAllPatients();
  }, []);

  // Getting all procedures
  useEffect(function () {
    async function getAllProcedures() {
      try {
        setIsGettingProcedures(true);
        const res = await treatmentsController.getProcedure(0, "");
        setAllProcedures(res.json);
      } catch (err) {
        message.error("Something went wrong while fetching procedures");
        console.error(err);
      } finally {
        setIsGettingProcedures(false);
      }
    }
    getAllProcedures();
  }, []);

  // Fetch the insurance data
  useEffect(
    function () {
      if (selectedBreakdown === null) return;
      getBreakdownsDetailsData();
    },
    [selectedBreakdown],
  );

  // Sending a POST request to set the patient id for the patient
  // useEffect(
  //   function () {
  //     // return in case that temp patient or selected patient (from the from down) was undefined or null
  //     if (!tempSelectedPatients.selected_patient) return;

  //     async function handleEditInsurancePatient() {
  //       setIsSettingPatientId(true);
  //       try {
  //         const response = await controller.setBreakdownSetPatient({
  //           policy_id: selectedBreakdown.procedure_coverages[0].insurance_policy,
  //           breakdown_id: selectedBreakdown.id,
  //         });

  //         if (response.status < 250) {
  //           getBreakdownsDetailsData();
  //         }
  //       } catch (err) {
  //         console.log(err);
  //         message.error("Something went wrong while setting the patient id.");
  //       } finally {
  //         setIsSettingPatientId(false);
  //       }
  //     }
  //     handleEditInsurancePatient();
  //   },
  //   [tempSelectedPatients],
  // );

  // Setting breakdown status, patient name and status label color
  useEffect(function () {
    setBreakdownStatus(selectedBreakdown.status);
    if (selectedBreakdown.text) setPatientName(JSON.parse(jsonrepair(selectedBreakdown.text)).patient_name);

    const { statusBackgroundColor, statusColor } = statusLableColor(selectedBreakdown && selectedBreakdown.status);
    setBreakdownStatusLabelColor({ statusBackgroundColor, statusColor });
  }, []);

  useEffect(
    function () {
      if (data && data.patient && allPatients) {
        const patient = allPatients.find((patient) => patient.id === data.patient);
        setSelectedPatient(patient);
      }
    },
    [data, allPatients],
  );

  // SECTION: Functions
  async function getAllPatients() {
    try {
      setIsGettingPatients(true);
      const res = await controller.getPatient2();
      setAllPatients(res);
    } catch (err) {
      message.error("Something went wrong while fetching patients");
      console.error(err);
    } finally {
      setIsGettingPatients(false);
    }
  }

  async function getBreakdownsDetailsData() {
    try {
      setIsLoadingBreakdownsData(true);
      await fetchData();
    } catch (err) {
      message.error("Something went wrong while getting insurance details data.");
      console.log(err);
    } finally {
      setIsLoadingBreakdownsData(false);
    }
  }

  if (isLoadingInsuranceData || isGettingPatients || isGettingProcedures || !data)
    return (
      <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, gap: 10 }}>
        <Spin />
        loading...
      </div>
    );

  // This needs to be updated to manage the approve for predetermination and post payment, expect the id we need to send the status (predetermination/post payment).
  const handleApprove = async () => {
    setIsApproving(true);
    try {
      const response = await controller.approveBreakdown(selectedBreakdown.id);

      if (response.status < 250) {
        message.success("Approved successfully!");
        setIsApproved(true);
        setBreakdownStatus(response.json.status);

        await treatmentsController.recalculateBreakdown(selectedBreakdown.id);

        const { statusBackgroundColor, statusColor } = statusLableColor(response.json.status);
        setBreakdownStatusLabelColor({ statusBackgroundColor, statusColor });
      } else {
        message.error(response.json ? JSON.stringify(response.json) : "Something went wrong!");
      }
    } catch (e) {
      message.error("Internal server Error");
    }
    await fetchData();
    setIsApproving(false);
  };

  function handleBack() {
    setSelectedBreakdown(null);
    if (selectedBreakdown.summary) setSummaryOfSelectedBreakdown([]);
  }

  return (
    <div style={{ padding: "20px 40px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 25 }}>
        <p style={{ fontSize: 18, fontWeight: 600, marginBottom: 0 }}>{patientName}'s Insurance Breakdowns</p>

        <Button
          type="primary"
          style={{
            border: "2px solid #6b43b5",
            color: "#6b43b5",
            backgroundColor: "#ffffff",
            display: "flex",
            alignItems: "center",
            fontSize: 16,
          }}
          onClick={handleBack}
        >
          <img src={arrowLeft} alt="arrow-left" />
          Back
        </Button>
      </div>

      <Card style={{ width: "100%", marginBottom: 30 }}>
        <div className="breakdown-labels-container">
          <BreakdownFinanceLabel status="Preventative" data={breakdownPatientCoverageData} />
          <BreakdownFinanceLabel status="Basic" data={breakdownPatientCoverageData} />
          <BreakdownFinanceLabel status="Major" data={breakdownPatientCoverageData} />
          <BreakdownFinanceLabel status="Orthodontic" data={breakdownPatientCoverageData} />
        </div>

        {breakdownStatus !== "approved" && !isApproved && (
          <div className="breakdowns-blur-effect">
            <div className="breakdowns-blur-effect-text">Please select patient and approve to see breakdown</div>
          </div>
        )}
      </Card>

      <Card>
        <div>
          <Row className="post-payment-status">
            <p style={{ fontSize: 18, marginBottom: 0 }}>Patient Information</p>

            <div>
              <span style={{ color: "#848696", fontSize: 16 }}>Status: </span>
              <span
                style={{
                  backgroundColor: breakdownStatusLabelColor.statusBackgroundColor,
                  color: breakdownStatusLabelColor.statusColor,
                  padding: "1px 24px",
                  borderRadius: 100,
                  fontSize: 14,
                  textTransform: "capitalize",
                }}
              >
                {breakdownStatus || (selectedBreakdown && selectedBreakdown.status)}
              </span>
            </div>
          </Row>

          <div className="breakdown-submission-received-date">
            <Col style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 16, whiteSpace: "nowrap" }} className="breakdown-patient-row">
              <span style={{ color: "#848696" }}>Extracted Patient:</span>
              <span>{patientName || "-"}</span>
            </Col>

            <Col style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 16, whiteSpace: "nowrap" }} className="breakdown-patient-row">
              <span style={{ color: "#848696" }}>Related Patient:</span>

              <PatientDropdown
                customClass="patient-dropdown-bigger-width"
                setShowSelectPolicyItemModal={setShowSelectPolicyItemModal}
                setIsPatientDropdownEmpty={setIsPatientDropdownEmpty}
                setTempSelectedPatients={setTempSelectedPatients}
                currentPatientName={selectedBreakdown.patient}
                isApproved={breakdownStatus === "approved"}
                isSettingPatientId={isSettingPatientId}
                setSelectedPatient={setSelectedPatient}
                setShowAddPatient={setShowAddPatient}
                getAllOfficePatients={getAllPatients}
                selectedPatient={selectedPatient}
                allPatients={allPatients}
              />
            </Col>
          </div>
        </div>

        <Card>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <p style={{ fontSize: 18 }}>Insurance Result</p>

            <div className="insurance-labels-text breakdown-submission-label">
              <span style={{ color: "#848696", textWrap: "nowrap" }}>Expiry Date: </span>
              <span style={{ minWidth: 85 }}>{data && data.submission_date ? moment(data.submission_date).format("DD/MM/YYYY") : "-"}</span>
            </div>
          </div>

          <div>
            <InsuranceBreakDownProceduresTable
              getBreakdownsDetailsData={getBreakdownsDetailsData}
              selectedBreakdown={selectedBreakdown}
              allProcedures={allProcedures}
              setTableData={setTableData}
              isApproved={isApproved}
              tableData={tableData}
            />
          </div>
        </Card>

        {data && data.files && data.files.length > 0 && (
          <div style={{ marginTop: 30 }}>
            <p style={{ fontSize: 18 }}>Uploaded Files</p>

            <div style={{ display: "flex", alignItems: "center", flexDirection: "row", flexWrap: "wrap", gap: 20 }}>
              {data.files.map((file, index) => (
                <InsuranceBreakDownUploadedFile key={index} file={file} />
              ))}
            </div>
          </div>
        )}
      </Card>

      <div style={{ marginTop: 30, display: "flex", marginBottom: 90 }}>
        <ApproveButton
          handleApprove={handleApprove}
          breakdownStatus={breakdownStatus}
          isPatientDropdownEmpty={isPatientDropdownEmpty}
          isSettingPatientId={isSettingPatientId}
          isApproved={isApproved}
          isApproving={isApproving}
        />
      </div>

      {/* Modal for adding patient */}
      <AddPatientModal showAddPatient={showAddPatient} setShowAddPatient={setShowAddPatient} getAllOfficePatients={getAllPatients} />

      {/* Select policy item modal */}
      <SelectPolicyItemModal
        breakdownToSetPolicy={selectedBreakdown}
        patientID={selectedPatient && selectedPatient.id}
        showSelectPolicyItemModal={showSelectPolicyItemModal}
        setShowSelectPolicyItemModal={setShowSelectPolicyItemModal}
      />
    </div>
  );
}
